import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiRequestError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Logo } from '../components/Logo';
import { Alert, Button, Field } from '../components/ui';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      const session = await login(email, password);
      navigate(session.admin.mustChangePassword ? '/trocar-senha' : '/', { replace: true });
    } catch (caught) {
      setError(
        caught instanceof ApiRequestError ? caught.displayMessage : 'Nao foi possivel entrar',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    /*
     * Fundo escuro com o cartao claro por cima: e a primeira tela do sistema, e
     * a unica sem menu ao redor para dar contexto. O contraste faz o formulario
     * ser a unica coisa que pede atencao.
     */
    <div className="relative grid min-h-full place-items-center overflow-hidden bg-brand-950 p-4">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 -right-32 size-96 rounded-full bg-brand-500/25 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -left-32 size-96 rounded-full bg-brand-400/15 blur-3xl"
      />

      <form
        onSubmit={handleSubmit}
        className="relative w-full max-w-sm space-y-5 rounded-2xl bg-white p-7 shadow-raised"
      >
        <div>
          <Logo className="mb-4 size-12" />
          <h1 className="text-xl font-bold text-slate-900">Hotspot Manager</h1>
          <p className="mt-1 text-sm text-slate-500">Acesso restrito a administradores.</p>
        </div>

        {error ? <Alert>{error}</Alert> : null}

        <Field
          label="E-mail"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="username"
          required
          autoFocus
        />

        <Field
          label="Senha"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password"
          required
        />

        <Button type="submit" disabled={submitting} className="w-full">
          {submitting ? 'Entrando...' : 'Entrar'}
        </Button>
      </form>
    </div>
  );
}
